import path from "path";

import { ForkedProcess } from "../../fork/process";
import { resolveSource } from "../../select";

export function startUnitTests(io: SocketIO.Server) {
  if (!["enabled", "disabled"].includes(process.env.EXCITARE_ASYNC_TRACES!)) {
    throw new Error("Expected EXCITARE_ASYNC_TRACES to be either 'enabled' or 'disabled'");
  }

  return new ForkedProcess(
    "unit_tests",
    path.join(__dirname, "../../"),
    resolveSource(path.join(__dirname, "./process")),
    [
      "-r",
      process.env.SHOULD_USE_TSNODE
        ? require.resolve("ts-node/register")
        : require.resolve("source-map-support/register"),
      process.env.EXCITARE_ASYNC_TRACES === "enabled" && "--async-stack-traces",
      "--no-deprecation"
    ].filter(Boolean) as string[],
    {
      projectDir: path.resolve(process.cwd()),
      EXCITARE_ASYNC_TRACES: process.env.EXCITARE_ASYNC_TRACES
    },
    ["tests"],
    io
  );
}
